import { render, staticRenderFns } from "./card-row.vue?vue&type=template&id=ae4f9ade&scoped=true&"
import script from "./card-row.vue?vue&type=script&lang=js&"
export * from "./card-row.vue?vue&type=script&lang=js&"
import style0 from "./card-row.vue?vue&type=style&index=0&id=ae4f9ade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4f9ade",
  null
  
)

export default component.exports